export default "__VITE_ASSET__DlPTJ7zL__"